import { render, staticRenderFns } from "./Locale.vue?vue&type=template&id=af83d28a&"
import script from "./Locale.vue?vue&type=script&lang=js&"
export * from "./Locale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports